<template>
  <div class="container page">
    <van-nav-bar :title="$t('router.Withdraw.title')" class="nav-bar">
      <template #left>
        <van-icon name="arrow-left" color="#fff" @click="back()"/>
      </template>
      <template #right>
        <span class="nav-right" @click="$router.push({path:'/WithdrawRecord'})">{{ $t('router.WithdrawRecord.title') }}</span>
      </template>
    </van-nav-bar>
    <div class="main">
      <div class="withdrawMoney">
        <span>{{ $t('mine.withdraw.amountLabel') }}</span>
        <div class="money">
          <div class="moneyNumber">
            <span class="moneyType">¥</span>
            <van-field v-model="withdraw_money" type="number" />
          </div>
          <span class="all" @click="allMoeny()">{{ $t('mine.withdraw.all') }}</span>
        </div>
        <div class="information">
          <div class="description">
            <van-popover v-model="showPopover" trigger="click">
              <div class="popover-body" style="padding: 10px;">
                <p>{{ $t('mine.withdraw.limitRule1', { min: this.withdrawRole.min, max: this.withdrawRole.max }) }}</p>
                <p>{{ $t('mine.withdraw.limitRule2', { num: this.withdrawRole.num }) }}</p>
                <p>{{ $t('mine.withdraw.limitRule3') }}</p></div>
              <template #reference @click="withdrawInfo()">
                <van-icon name="info-o" />
                {{ $t('mine.withdraw.limitTitle') }}
              </template>
            </van-popover>
          </div>

          <div class="balance">
            <span>{{ $t('mine.withdraw.balanceLabel') }}</span>
            <span class="number">{{ this.userInfo.money }}{{ $t('lottery.yuan') }}</span>
          </div>
        </div>
      </div>
      <div class="pay-methods">
        <div class="pm-title">{{ $t('payMethod.title') }}</div>
        <div class="pm-item" v-for="item in payMethods" :key="item.id" :class="{active: bankId === item.id}" @click="chooseMethod(item)">
          <div class="pm-info">
            <div class="pm-type">{{ item.type == 1 ? $t('payMethod.bankCard') + (item.bankinfo ? ' · ' + item.bankinfo : '') : $t('payMethod.wallet') + (item.coin ? ' · ' + item.coin.toUpperCase() : '') }}</div>
            <div class="pm-addr">{{ item.bankid }}</div>
          </div>
          <van-icon :name="bankId === item.id ? 'checked' : 'circle'" :class="['pm-check', {on: bankId === item.id}]" />
        </div>
        <div class="pm-empty" v-if="!payMethods.length">{{ $t('common.emptyData') }}</div>
      </div>
      <van-button class="withdraw_btn" type="default" @click="doWithdraw()">{{ $t('mine.withdraw.submit') }}</van-button>

    </div>
    <!-- 提交前提现密码验密：验密失败弹窗不关，可直接重输 -->
    <van-dialog v-model="showPwd" :title="$t('payMethod.payPassword')" show-cancel-button :before-close="pwdBeforeClose">
      <van-field v-model="payPassword" type="password" :placeholder="$t('payMethod.payPassword')" class="pwd-field" />
    </van-dialog>
  </div>
</template>

<script>
export default {
  data() {
    return {
      showPopover: false,
      withdraw_money:"",
      userInfo:{},
      withdrawRole:{},
      payMethods:[],
      bankId:0,
      showPwd:false,
      payPassword:""
    };
  },
  methods: {
    back(){
      return window.history.back();
    },
    getUserInfo(){
      this.$http({
        method: 'get',
        url: 'user_info'
      }).then(res=>{
        if(res.code === 200){
          this.userInfo = res.data;
          this.name = res.data.name;
        }else if(res.code ===401){
          this.$toast(res.msg);
        }
      })
    },
    getUserWithdrawRole(){
      this.$http({
        method: 'get',
        url: 'user_get_withdraw_role'
      }).then(res=>{
        if(res.code === 200){
          this.withdrawRole = res.data;
        }else if(res.code ===401){
          this.$toast(res.msg);
        }
      })
    },
    allMoeny(){
      this.withdraw_money = this.userInfo.money;
    },
    getPayMethods(){
      this.$http({
        method: 'get',
        url: 'user_get_paymethod'
      }).then(res=>{
        if(res.code === 200){
          this.payMethods = Array.isArray(res.data) ? res.data : [];
          if(this.payMethods.length){
            this.bankId = this.payMethods[0].id;
          }
        }else if(res.code ===401){
          this.$toast(res.msg);
        }
      })
    },
    chooseMethod(item){
      this.bankId = item.id;
    },
    doWithdraw(){
      if(this.withdraw_money <= 0){
        this.$toast(this.$t('mine.withdraw.amountInvalid'));
        return false;
      }
      if(!this.bankId){
        this.$toast(this.$t('payMethod.chooseFirst'));
        return false;
      }
      this.payPassword = "";
      this.showPwd = true;
    },
    // 验密失败保持弹窗不关，可直接重输
    pwdBeforeClose(action, done){
      if(action !== 'confirm'){
        done();
        return;
      }
      if(!this.payPassword){
        this.$toast(this.$t('common.passwordRequired'));
        done(false);
        return;
      }
      this.$http({
        method: 'post',
        data:{money:this.withdraw_money, bank_id:this.bankId, paypassword:this.payPassword},
        url: 'user_set_withdraw'
      }).then(res=>{
        if(res.code === 200){
          this.$toast(res.msg);
          this.withdraw_money = "";
          this.getUserInfo();
          this.getUserWithdrawRole();
          done();
        }else {
          this.$toast(res.msg);
          done(false);
        }
      })
    },
    withdrawInfo(){
      this.showPopover = true;
    }
  },
  created() {
    if(!localStorage.getItem('token')){
      this.$router.push({path:'/Login'})
    }else {
      this.getUserInfo();
      this.getUserWithdrawRole();
      this.getPayMethods();
    }
  }
};
</script>

<style lang='less' scoped>
@import "../../assets/css/base.css";
.van-cell {
  font-size: 35px;
  line-height: 80px;
}
.container p{
  padding: 0 15px;
  margin-top: 15px;
  font-size: 30px;
  color: #dc2037;
}
.container .main{
  display: flex;
  flex-direction: column;
  background-color: #f2f2f5;
  height: calc(100% - 50px);
  position: relative;
}
.container .main .withdrawMoney{
  display: flex;
  flex-direction: column;
  color: #000;
  padding: 0 20px;
  white-space: nowrap;
  font-size: 35px;
  background-color: #fff;
}
.container .main .withdrawMoney span {
  padding: 10px 0;
}
.container .main .withdrawMoney .money{
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  border-bottom: 1px solid #f2f2f5;
}
.container .main .withdrawMoney .money .moneyNumber{
  font-size: 50px;
  display: flex;
  flex-direction: row;
}
.container .main .withdrawMoney span {
  padding: 10px 0;
}
.container .main .withdrawMoney .money .all{
  color: #d10404;
}
.container .main .withdrawMoney .money .moneyNumber .van-cell {
  font-size: 50px;
  padding: 0!important;
}
.container .main .withdrawMoney .information{
  padding-bottom: 30px;
}
.container .main .withdrawMoney .information .description {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  padding: 10px 0;
}
.container .main .withdrawMoney span{
  padding: 10px 0;
}
.container .main .withdrawMoney .information .balance .number{
  color: #d10404;
}
.withdraw_btn {
  margin: 20px 30px 0;
  height: 80px;
  line-height: 1.22667rem;
  border-radius: 50px;
  color: #fff;
  font-size: 30px;
  font-weight: bolder;
  border: none;
  background: linear-gradient(
      90deg,#e6c3a1,#7e5678);
}
.pay-methods{
  margin: 20px 0 0;
  background-color: #fff;
  padding-bottom: 10px;
}
.pm-title{
  padding: 25px 20px 10px;
  font-size: 30px;
  color: #979799;
}
.pm-item{
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  margin: 0 20px;
  padding: 20px;
  border-radius: 10px;
  border: 2px solid #f2f2f5;
}
.pm-item.active{
  border: 2px solid #7e5678;
}
.pm-item .pm-info{
  flex: 1;
  min-width: 0;
}
.pm-item .pm-type{
  font-size: 28px;
  font-weight: bolder;
  color: #000;
}
.pm-item .pm-addr{
  margin-top: 10px;
  font-size: 24px;
  color: #979799;
  word-break: break-all;
}
.pm-item .pm-check{
  margin-left: 20px;
  font-size: 40px;
  color: #c8c9cc;
}
.pm-item .pm-check.on{
  color: #7e5678;
}
.pm-empty{
  padding: 30px 0;
  text-align: center;
  font-size: 26px;
  color: #979799;
}
.pwd-field{
  padding: 20px 0;
}
</style>
